module.exports = __webpack_public_path__ + "img/banner4.de518541.jpg";